import { type IDoctor } from '@/app/types/doctorsType'
import { InfiniteScrollList, Loader, PageWrapper } from '@/shared'

import { DoctorCard } from './DoctorCard/DoctorCard'
import style from './List.module.scss'

interface IProps {
    list: IDoctor[] | null
    getDoctorsCallback: () => void
    isFetching: boolean
}

export const List = (props: IProps) => {
    const { list, getDoctorsCallback, isFetching } = props

    const isInfiniteScrollConditions = !isFetching

    return (
        <PageWrapper>
            {list ? (
                <InfiniteScrollList
                    className={style.container}
                    callback={getDoctorsCallback}
                    isConditions={isInfiniteScrollConditions}
                    isFetching={isFetching}
                >
                    {list.map((doctor, idx) => (
                        <DoctorCard key={`${doctor.doctorId}-${idx}`} {...doctor} />
                    ))}
                </InfiniteScrollList>
            ) : (
                <div className={style.loaderContainer}>
                    <Loader />
                </div>
            )}
        </PageWrapper>
    )
}
